import React, { useState, useEffect } from "react";
import "./loading.css"
import {color } from "./../../utils/themes/color"
import { Bars, Circles } from '@agney/react-loading';



export default function LOADING(props) {
    var Color = color.primary;
    if (props.color != undefined) {
        Color = props.color
    }

    switch (props.type) {
        case "xxl": return (
            <div style={{ width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bars width="80" style={{ color: Color }} />
            </div>
        )
        case "xl": return (
            <div style={{ width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bars width="60" style={{ color: Color }} />
            </div>
        )
        case "lg": return (
            <div style={{ width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bars width="40" style={{ color: Color }} />
            </div>
        )
        default: return (
            <div style={{ width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bars width="20" style={{ color: Color }} />
            </div>
        )
    }

}